import React from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, TrashIcon } from 'lucide-react';
import { CartItem as CartItemType } from '../../types';
import { useCart } from '../../context/CartContext';
interface CartItemProps {
  item: CartItemType;
}
export function CartItem({
  item
}: CartItemProps) {
  const {
    updateQuantity,
    removeFromCart
  } = useCart();
  const {
    product,
    quantity
  } = item;
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('uk-UA').format(price);
  };
  return <div className="flex gap-4 py-4 border-b border-slate-100 last:border-0" data-id="element-40">
      {/* Image */}
      <Link to={`/product/${product.id}`} className="flex-shrink-0 w-24 h-24 rounded-xl overflow-hidden bg-slate-100" data-id="element-41">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" data-id="element-42" />
      </Link>

      {/* Content */}
      <div className="flex-1 min-w-0" data-id="element-43">
        <Link to={`/product/${product.id}`} className="text-sm font-medium text-slate-800 hover:text-sky-600 transition-colors line-clamp-2" data-id="element-44">
          {product.name}
        </Link>

        <div className="mt-2 flex items-center justify-between gap-4" data-id="element-45">
          {/* Quantity Controls */}
          <div className="flex items-center gap-1" data-id="element-46">
            <button onClick={() => updateQuantity(product.id, quantity - 1)} className="p-1.5 rounded-lg hover:bg-slate-100 transition-colors disabled:opacity-50" disabled={quantity <= 1} aria-label="Зменшити кількість" data-id="element-47">
              <MinusIcon className="w-4 h-4 text-slate-600" data-id="element-48" />
            </button>
            <span className="w-10 text-center text-sm font-medium text-slate-800" data-id="element-49">
              {quantity}
            </span>
            <button onClick={() => updateQuantity(product.id, quantity + 1)} className="p-1.5 rounded-lg hover:bg-slate-100 transition-colors" aria-label="Збільшити кількість" data-id="element-50">
              <PlusIcon className="w-4 h-4 text-slate-600" data-id="element-51" />
            </button>
          </div>

          {/* Price */}
          <div className="text-right" data-id="element-52">
            <div className="text-sm font-bold text-slate-900" data-id="element-53">
              {formatPrice(product.price * quantity)} ₴
            </div>
            {quantity > 1 && <div className="text-xs text-slate-500" data-id="element-54">
                {formatPrice(product.price)} ₴ / шт
              </div>}
          </div>
        </div>
      </div>

      {/* Remove Button */}
      <button onClick={() => removeFromCart(product.id)} className="flex-shrink-0 p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" aria-label="Видалити з кошика" data-id="element-55">
        <TrashIcon className="w-5 h-5" data-id="element-56" />
      </button>
    </div>;
}